import { SkuGroup } from 'src/types/redeemCode';

import { EnrollmentGroup } from '../../types/enrollment';
import { Speech } from '../../types/speech';
import { GTeacher } from '../../types/teacher';
import { TeacherAllocation } from '../group/AllocateTeacher';
import { User } from '../user/Users';

export interface Course {
  id: number;
  name: string;
  description: string;
  updatedAt: string;
  createdAt: string;
  lessons: Lesson[];
  teachingPoints: TeachingPoint[];
  serialId: string;
}

// 可以购买的商品
export interface Sku {
  id: number; // 商品唯一识别ID
  name: string; // 商品名
  groups: SkuGroup[];
  price: number; // 单价
  start: string; // 课程开始时间
  end: string; // 课程结束时间
  course: Course;
  courseId?: number;
  quizEndAt: Date; // 问答结束时间
  createdAt: string; // 创建时间
  enrollmentGroups: EnrollmentGroup[];
  teacherAllocations: TeacherAllocation[];
  noneGroupEnrollments: Enrollment[]; // 未分配班级的Enrollment
  // workGoal: WorkGoal;
}

// export interface WorkGoal {
//   closeStageStartAt: Date;
//   closeStageEndAt: Date;
// }

export enum EnrollmentSource {
  UNKNOWN,
  ORDER,
  ADMIN,
  UPGRADE,
}

export interface Enrollment {
  id: number; // 报名ID
  sku: Sku;
  learnOverview: LearnOverview;
  scheduleProgress: ScheduleProgress;
  lessonProgresses: LessonProgresses[];
  enrollmentReport: EnrollmentReport;
  group: {
    id: number;
    name: string;
    teacher: GTeacher;
  };
  miniGameResults: MiniGameResult[];
  attendances: Attendance[];
  source: EnrollmentSource;
  sourceId: number;
}
export interface MiniGameResult {
  id: number;
  userId: number;
  miniGameId: number;
  result: number;
  data: AdmissionQuizData;
  createdAt: string;
}
export interface AdmissionQuizData {
  resultRecord: boolean[];
  knowledgeLevel: number;
  level: number;
  time: number;
}
export interface EnrollmentReport {
  knowledgePoints: Statistics[];
  lessonNames: string[];
}

export interface LessonProgresses {
  serialId: string;
  displayId: string;
  unlockAt: Date;
  lesson: Lesoon;
  status: number;
  recentLearnAt: Date;
  learnReports: LearnReport[];
  evaluations: Evaluation[];
  knowledgePoints: Statistics[];
}

interface Lesoon {
  id: number;
  type: number;
  name: string;
}

export interface LearnReport {
  learnAt: string;
  learnEndAt: string;
  learnDuration: number;
  type: LessonType;
  overviewStatistics: Statistics;
  knowledgePoints: Statistics[];
  cognitiveProcesses: Statistics[];
  applyAbilities: Statistics[];
  partStatistics: PartStatistics[];
}

export enum LessonType {
  UNKNOWN,
  LESSON, // 课时
  EXERCISE, // 练习
}

export enum TeachingPointType {
  KNOWLEDGE_POINT, // 知识点
  CONGNITIVE_PROCESS, // 认知过程
  APPLY_ABILITY, // 应用能力
}

export interface Lesson {
  id: number;
  name: string;
  type: LessonType;
  displayId?: string;
  serialId: string;
}

export interface TeachingPoint {
  id: number;
  name: string;
  type: TeachingPointType;
}

export interface Statistics {
  name: string;
  parts: string;
  curve: string;
  reinforcement: number;
  highestAccuracy: number;
  accuracy: number;
  speed: number;
  speech: Speech;
}

interface PartStatistics {
  name: string;
  teachingPoints: [TeachingPoint];
  statistics: Statistics;
}

interface Evaluation {
  id: number;
}

export enum LessonStatus {
  COMING, // 尚未开课
  LOCKED, // 未解锁
  UNLOCKED, // 已解锁
  HIGHLIGHT, // 已解锁-推荐上课
  PLAYED, // 已上课
}

export interface LearnOverview {
  learnDayCount: number;
  learnDuration: number;
  knowledgePointCount: number;
}

export interface ScheduleProgress {
  unlockCount: number;
  onTimeCount: number;
  makeUpCount: number;
  makeUpLessons: Lesson[];
  missedLessons: Lesson[];
}

export interface Variables {
  ids?: number[];
  enrollmentIds: number[];
}

export interface UserData {
  users: User[];
}

export enum MiniGameNames {
  GRIND = 'grind',
  EULER_QUIZ = 'euler-quiz',
  EULER_FORTUNE_MATCH = 'euler-fortune-match',
  ADMISSION_QUIZ = 'admission-quiz',
}

export interface Attendance {
  id: number;
  attendanceId: number;
  createdAt: Date;
  attendanceLogs: [IAttendanceLog];
}

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
export interface IAttendanceLog {
  id: number;
  event: number;
  attendanceId: number;
  key: string;
}



// WEBPACK FOOTER //
// ./src/screens/enrollment/Enrollment.tsx